import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loader from "../Loader";

const TeamRoute = ({ children }) => {
  const { isAuthenticated, loading, isAuthInitializing } = useAuth();

  if (loading || isAuthInitializing) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default TeamRoute;
